import React, { useContext } from 'react';
const LocationContext = /*#__PURE__*/React.createContext(window.location);
/** @deprecated */
export function LocationProvider(props) {
  const {
    children,
    location
  } = props;
  return /*#__PURE__*/React.createElement(LocationContext.Provider, {
    value: location
  }, children);
}

/** @deprecated use the hook from react-router instead. */
export const useLocation = () => {
  return useContext(LocationContext);
};

/** @deprecated */
export const useLocationCommonActions = () => {
  const locationContext = useContext(LocationContext);
  return {
    getPageUrl: () => {
      return locationContext.origin + locationContext.pathname;
    }
  };
};